import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { KanbanFakeGroup } from "~/components/KanbanFakeGroup";
import { KanbanColumnContainer } from "./shared/KanbanColumnContainer";
export const KanbanLoadingState = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "h-full",
        children: /*#__PURE__*/ _jsxs(KanbanFakeGroup, {
            children: [
                /*#__PURE__*/ _jsx(KanbanColumnContainer, {
                    isLoading: true
                }),
                /*#__PURE__*/ _jsx(KanbanColumnContainer, {
                    isLoading: true
                }),
                /*#__PURE__*/ _jsx(KanbanColumnContainer, {
                    isLoading: true
                }),
                /*#__PURE__*/ _jsx(KanbanColumnContainer, {
                    isLoading: true
                }),
                /*#__PURE__*/ _jsx(KanbanColumnContainer, {
                    isLoading: true
                })
            ]
        })
    });
});
KanbanLoadingState.displayName = "KanbanLoadingState";
